import { action, mutator } from "satcheljs";
import type { FlexPaneState } from "../store/store";
import { getStore } from "../store/store";
import { getDefaultFlexPaneWidth } from "../utils/getDefaultFlexPaneWidth";

export interface SetIsFlexPaneShownActionMessage {
    flexPaneId: string;
    isShown: boolean;
}
export const setIsFlexPaneShown: (flexPaneId: string, isShown: boolean) => SetIsFlexPaneShownActionMessage = action("setIsFlexPaneShown", (flexPaneId: string, isShown: boolean): SetIsFlexPaneShownActionMessage => ({
    flexPaneId,
    isShown,
}));

export const setIsFlexPaneShownMutator: (actionMessage: SetIsFlexPaneShownActionMessage) => void = mutator(setIsFlexPaneShown, actionMessage => {
    const flexPaneId = actionMessage.flexPaneId;
    let flexPaneState: FlexPaneState | undefined = getStore().flexPaneStateMap.get(flexPaneId);
    
    // Update FlexPaneState if it exists, otherwise create one
    if (flexPaneState) {
        flexPaneState.isShown = actionMessage.isShown;
    }
    else {
        flexPaneState = {
            isShown: actionMessage.isShown,
            isExpanded: false,
            expandedWidth: getDefaultFlexPaneWidth(flexPaneId),
        };
        getStore().flexPaneStateMap.set(flexPaneId, flexPaneState);
    }
    
    getStore().currentFlexPaneState = flexPaneState;
});
